import { render, staticRenderFns } from "./AdminPanelLayout.vue?vue&type=template&id=3c6826b8&scoped=true"
import script from "./AdminPanelLayout.vue?vue&type=script&lang=js"
export * from "./AdminPanelLayout.vue?vue&type=script&lang=js"
import style0 from "./AdminPanelLayout.vue?vue&type=style&index=0&id=3c6826b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6826b8",
  null
  
)

export default component.exports